// extracted by mini-css-extract-plugin
export var buy__btn = "sellingBlockModules-module--buy__btn--0a322";
export var getCourse = "sellingBlockModules-module--get-course--128df";
export var getCourse__buttons = "sellingBlockModules-module--get-course__buttons--9fb85";
export var getCourse__container = "sellingBlockModules-module--get-course__container--ab8b0";
export var getCourse__name = "sellingBlockModules-module--get-course__name--9c1bb";
export var getCourse__number = "sellingBlockModules-module--get-course__number--ce82d";
export var getCourse__text = "sellingBlockModules-module--get-course__text--20c6b";
export var getCourse__title = "sellingBlockModules-module--get-course__title--eb611";
export var getCourse__window = "sellingBlockModules-module--get-course__window--f3c82";
export var getCourse__writeoff = "sellingBlockModules-module--get-course__writeoff--38ba1";
export var get__btn = "sellingBlockModules-module--get__btn--27acb";
export var main__btn = "sellingBlockModules-module--main__btn--73a0a";